module.exports = __webpack_public_path__ + "static/media/image7.3602b136.jpg";